import { jsx as _jsx } from "react/jsx-runtime";
import { TextField, InputAdornment, useMediaQuery } from '@mui/material';
import { SearchNormal1 } from 'iconsax-react';
import React from 'react';
export const SearchField = ({ mt = 0, mb = 0, placeholder, fullWidth = false, bgColor, placeholderColor = '#141414', searchQuery, onSearchChange }) => {
    const isSmallScreen = useMediaQuery('(max-width:605px)');
    const handleChange = (event) => {
        if (onSearchChange)
            onSearchChange(event.target.value);
    };
    return (_jsx(TextField, { sx: {
            mt: mt,
            mb: mb,
            background: bgColor && bgColor,
            borderRadius: '25px',
            '& .MuiInputBase-input::placeholder': {
                color: placeholderColor
            }
        }, id: 'outlined-basic', fullWidth: isSmallScreen ? true : fullWidth, InputLabelProps: { shrink: false }, variant: 'outlined', placeholder: placeholder, value: searchQuery, onChange: handleChange, InputProps: {
            startAdornment: (_jsx(InputAdornment, { position: 'start', children: _jsx(SearchNormal1, { color: placeholderColor }) }))
        } }));
};
